
export { WalletTabContainer } from "/home/runner/work/capsicum/capsicum/libs/features/wallet/web/src/feature/index.ts"